import { DonutCard } from './DashboardCards'
import { DashTrendCard } from './DashTrendCard'
import { MandalCoverageCard } from './MandalCoverageCard'
import { OfficerPushCard } from './OfficerPushCard'
import { DeltaBadge } from '../DeltaBadge'

import type { SiteStatus } from '../../../api/types'
import type { BoardShortcuts } from '../../../hooks/useBoardShortcuts'
import type { DashboardInsights } from '../../../hooks/useDashboardInsights'

interface CoverageInsightsPanelProps {
  i: DashboardInsights
  go: BoardShortcuts
}

/**
 * The COVERAGE dashboard modules — survey-status donut · officers needing a push · coverage trend,
 * then the worst-first coverage-by-mandal bars. Rendered by the Dashboard tab's Coverage section
 * AND the Coverage dashboard overlay, so the two can never drift.
 */
export function CoverageInsightsPanel({ i, go }: CoverageInsightsPanelProps) {
  return (
    <>
      <div className="grid grid-cols-1 gap-3 @[620px]/dash:grid-cols-2 @[980px]/dash:grid-cols-3">
        <DonutCard
          title="Sites by survey status"
          segments={i.covSegments}
          centerValue={i.coveragePct !== null ? `${i.coveragePct}%` : '—'}
          centerLabel="COVERAGE"
          onPick={(key) => go.goCoverage(key as SiteStatus)}
          onOpen={() => go.goCoverage()}
          openLabel="Open Coverage board"
        />
        <OfficerPushCard sites={i.scopedSites} pending={i.sitesPending} onOpen={go.goCoverageOfficers} />
        {/* Third card of the row: full-width when the row wraps to 2 columns (no empty hole),
            back to one column of three at wide. */}
        <div className="min-w-0 @[620px]/dash:col-span-2 @[980px]/dash:col-span-1">
          <DashTrendCard
            title="Coverage trend"
            values={i.trends.coverage}
            buckets={i.trendBuckets}
            bucketSize={i.trendBucketSize}
            accent="#10b981"
            unit="%"
            delta={i.coverageDelta !== null ? <DeltaBadge lens="coverage" delta={i.coverageDelta} /> : undefined}
          />
        </div>
      </div>
      <MandalCoverageCard mandals={i.scopedMandals} onPickMandal={go.goCoverageMandal} onOpen={() => go.goCoverage()} />
    </>
  )
}
